<template>
    <div>
        <div class="row">
            <div class="col-xs-12">
                <vc-pesquisa
                        :extra="extraClienteTecnico"
                        @input="setProprietarios"
                        label="Produtor / Proprietário"
                        :limpa-select="true"
                        :selecionado-config="{label : 'nome', campo : 'id'}"
                        url-busca="api/pessoas/pesquisa"
                        :campos-table="[ {'label' : 'Nome / Razão Social', 'campo' : 'nomerazao_social'}, {'label' : 'CPF / CNPJ', 'campo' : 'cpfcnpj'}]">
                </vc-pesquisa>
                <span v-if="proprietarios.length <= 0" class="text-danger"> <b>Informe ao menos um(01) proprietário</b></span>
            </div>
            <div class="col-xs-12">
                <table class="table table-striped">
                    <tbody v-for="(proprietario, index) in proprietarios">
                    <tr>
                        <td width="40%" class="text-capitalize">{{proprietario.nomerazao_social }}<br>{{ proprietario.fone }}</td>
                        <td width="25%">{{proprietario.cpfcnpj }}</td>
                        <td width="25%">{{proprietario.ie }}</td>
                        <td width="10%" class="text-center">
                            <button type="button" class="btn btn-danger  btn-xs" @click="proprietarios.splice(index, 1)"
                                    title="Remover proprietário">
                                <i class="fa fa-times"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <vc-pesquisa
                        :extra="extraClienteTecnico"
                        @input="setArrendatario"
                        label="Proprietário / Cedente"
                        :limpa-select="true"
                        :selecionado-config="{label : 'nome', campo : 'id'}"
                        url-busca="api/pessoas/pesquisa"
                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                </vc-pesquisa>
            </div>
            <div class="col-xs-12">
                <table class="table table-striped">
                    <tbody v-for="(arrendatario, index) in arrendatarios">
                    <tr>
                        <td width="40%" class="text-capitalize">{{arrendatario.nomerazao_social }}</td>
                        <td width="25%">{{arrendatario.cpfcnpj }}</td>
                        <td width="25%">{{arrendatario.ie }}</td>
                        <td width="10%" class="text-center">
                            <button type="button" class="btn btn-danger btn-xs" @click="arrendatarios.splice(index, 1)"
                                    title="Remover arrendatário">
                                <i class="fa fa-times"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import VcPesquisa from '@/components/Form/Pesquisa'
    import Bus from "../../bus"

    export default {
        props: {
            tipo: {},
            proprietarios: {
                default: () => []
            },
            arrendatarios: {
                default: () => []
            }
        },
        name: "AdicionarPessoas",
        components: {
            VcPesquisa
        },
        computed: {
            extraClienteTecnico() {
                return {
                    cliente: 1,
                    tecnico_agricola: 1
                }
            }
        },
        methods: {
            setArrendatario(arrendatario) {
                Bus.$emit('limpa-select')

                if (this.tipo !== 'SOLO' && this.arrendatarios.length >= 1) {
                    return window.swal("Atenção", "Você pode adicionar no máximo um arrendatário", "info");
                }

                let qtdProprietarios = this.proprietarios.length

                if ((qtdProprietarios + this.arrendatarios.length) == 4) {
                    return window.swal("Atenção", "Você já adicionou o máximo de pessoas", "info");
                }

                if (qtdProprietarios > 3) {
                    return this.$emit('setArrendatarios', []);
                }

                if (this.arrendatarios.length >= 2) {
                    return window.swal("Atenção", "Você pode adicionar no máximo 2 (dois) arrendatários", "info");
                } else if (this.arrendatarios.indexOf(arrendatario) <= -1) {
                    let arr = this.arrendatarios;
                    arr.push(arrendatario);
                    arr.adicionando = true
                    this.$emit('setArrendatarios', arr);
                } else return window.swal("Atenção", "Arrendatário já adicionado", "info");
            },

            setProprietarios(proprietario) {
                Bus.$emit('limpa-select')

                if (this.tipo !== 'SOLO' && this.proprietarios.length >= 1) {
                    return window.swal("Atenção", "Você pode adicionar no máximo um proprietário", "info");
                }

                if (this.proprietarios.length >= 3 && this.arrendatarios.length == 1) {
                    return window.swal("Atenção", "Você pode adicionar no máximo 3 proprietários", "info");
                }

                if ((this.proprietarios.length + this.arrendatarios.length) == 4) {
                    return window.swal("Atenção", "Você já adicionou o máximo de pessoas", "info");
                }

                if (this.proprietarios.indexOf(proprietario) <= -1) {
                    let prop = this.proprietarios;
                    prop.adicionando = true
                    prop.push(proprietario);
                    this.$emit('setProprietarios', prop);
                } else return window.swal("Atenção", "Proprietário já adicionado", "info");

                let qtdProprietarios = this.proprietarios.length;

                if (qtdProprietarios > 2) {
                    this.$emit('setArrendatarios', []);
                }
            }
        }

    }
</script>

<style scoped>

</style>